import { Modal } from "react-bootstrap";
import BaseCom from "../BaseCom";
import L from "../Lang";
import Icon from "../Icon";


class NumInput extends BaseCom {
    render() {
        return <div className="d-grid text-center">
            <div className="fs-2" onClick={this.props.up}>
                <Icon icon="faCaretUp" />
            </div>
            <div>
                <input type="text" value={this.props.value} className="text-center fs-2 border-0 form-control" />
            </div>
            <div className="fs-2" onClick={this.props.down}>
                <Icon icon="faCaretDown" />
            </div>
        </div>;
    }
}


export default class LogHoursModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            hours: 1,
            minutes: 0
        };
    }

    componentDidUpdate(prevProps) {
        if(this.props.show !== prevProps.show) {
            if(this.props.show)
                this.setState({ hours: 0 });
        }
    }

    changeVal = (v) => {
        let hours = this.state.hours + v;
        if(hours < 0)
            hours = 0;
        this.setState({ hours: hours });
    }

    toggleM = () => {
        let minutes = this.state.minutes;
        if(minutes === 30) minutes = 0;
        else minutes = 30;
        this.setState({ minutes: minutes });
    }
    
    submit = (e) => {
        e?.preventDefault();
        this.props.onSubmit(this.state.hours, this.state.minutes);
    }

    validate = () => {
        return this.state.hours || this.state.minutes;
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header>
                    <Modal.Title><L>Log Hours</L></Modal.Title>
                </Modal.Header>
                <form onSubmit={this.submit}>
                    <Modal.Body>
                        <div className="d-flex justify-content-center text-center">
                            <div>
                                <span className="text-muted">Hours</span>
                                <NumInput
                                    value={this.state.hours}
                                    up={() => this.changeVal(1)}
                                    down={() => this.changeVal(-1)}
                                />
                            </div>
                            <div>
                                <span className="text-muted">Minutes</span>
                                <NumInput
                                    value={this.state.minutes}
                                    up={() => this.toggleM()}
                                    down={() => this.toggleM()}
                                />
                            </div>
                        </div>

                       
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success d-block w-100 btn-lg" disabled={this.props.submitting || !this.validate()}>
                            <Icon icon="faSave" /> <L>Submit</L>
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        )
    }
}